// extracted by mini-css-extract-plugin
module.exports = {"container":"DialogWrapper_container__3lqOu","contentContainer":"DialogWrapper_contentContainer__3iFGp","logo":"DialogWrapper_logo__mL3Bf"};